---
title: Phaser
description: "A phaser device: a phaser or flanger mode, a rate or a note value, a depth, a centre frequency, a delay, a feedback and a mix, a panel that draws the sweep, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-phaser" />

Sweeps notches through the sound with a slow oscillator. In Phaser mode it is a chain of four all-pass filters around a centre frequency. In Flanger mode it is a very short delay. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="phaser" kind="device" />

## Controls

<DeviceControls device="phaser">
<Control id="mode">Phaser sweeps the filters, Flanger sweeps the delay. The controls the mode does not use are drawn off.</Control>
<Control id="rateHz">How fast the oscillator sweeps.</Control>
<Control id="sync">Takes the rate from a note value and the tempo of the host. See [Tempo sync](/docs/devices#tempo-sync).</Control>
<Control id="division">The note value of one cycle of the oscillator.</Control>
<Control id="depth">How far the oscillator moves the filters or the delay.</Control>
<Control id="centerHz">The frequency the phaser sweeps around.</Control>
<Control id="delayMs">The delay the flanger sweeps around.</Control>
<Control id="feedback">How much of the output goes back in, which deepens the notches.</Control>
<Control id="mix">The balance of the processed signal and the dry one.</Control>
</DeviceControls>

## Panel

The panel draws what the oscillator does over two seconds. `phaserSweep(state)` is what it draws, and `phaserSettings(state)` gives the numbers that go on the nodes.

<DeviceUsage name="phaser" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

Both paths are always built and the mode crossfades them, so switching does not click. One oscillator moves the filters, in cents, and the delay, in seconds. The flanger's sweep is kept inside its delay so the time never goes negative.
